// extracted by mini-css-extract-plugin
export default {"container":"NewJourney_container__8tqls"};